import React from 'react';

const PromotionFilter = () => (
  <div className="promotion-filter">
    <span className="container-menu-button">
      <button
        key="index_deliveries"
        type="button"
        className="menu-button active"
      >
        <span>Mis Entregas</span>
      </button>
    </span>
  </div>
);

export default PromotionFilter;
